import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot } from '@angular/router';
import { AuthService } from '../../admin/auth.service';
import { GestaoSsService } from '../services/gestao-ss.service';

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(private authService: AuthService, private gestaossService: GestaoSsService) { }

    canActivate(route: ActivatedRouteSnapshot) {
        if (!this.authService.isLoggedIn()) {
            this.gestaossService.redirecionaUsuarioParaoGestaoSS();
            return false;
        }

        const roles = route.data['roles'] as Array<string>;

        if (roles === undefined || roles.length === 0) {
            return true;
        }

        // TODO testar isso aqui é um saco
        const usuario = this.authService.informacoesUsuario();
        if (!roles.includes(usuario.Perfil)) {
            this.gestaossService.redirecionaUsuarioParaoGestaoSS();
            return false;
        }

        return true;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/shared/authentication/auth-guard.ts